:root{
    --colors-gray-500: "#6b7280";
}

@font-face {
    font-family: "RobotoMono";
    src: url("../assets/RobotoMono-VariableFont_wght.ttf");
}

.grilleCase {
    padding-left: 2px;
    padding-right: 3px;
    color: var(--colors-gray-500);
    border-top-color: black;
    background-color: white;
    font-family: "RobotoMono", monospace;
}

.grilleCaseTopStyleThick {
    border-top-width: 3px;
}

.grilleCaseTopStyleThin {
    border-top-width: 1px;
}
